import { render, staticRenderFns } from "./ChildStore.pug?vue&type=template&id=47734eac&scoped=true&lang=pug&"
import script from "./ChildStore.vue?vue&type=script&lang=js&"
export * from "./ChildStore.vue?vue&type=script&lang=js&"
import style0 from "./ChildStore.scss?vue&type=style&index=0&id=47734eac&lang=scss&scoped=true&"
import style1 from "./ChildStore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47734eac",
  null
  
)

export default component.exports